import React, { useMemo } from 'react';
import { useLinked } from "@type-r/react";
import { makeStyles } from '@material-ui/core';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { div, Loading } from 'lqx-react';
import { getAuthorizationBearer } from '../../api/endpoint';

export const PdfViewer = ({ url, $scale, $loaded }: { url: string, $scale, $loaded }) => {
    const classes = usePdfViewerStyles();
    const pdfFile = useMemo(() => ({
        url: url,
        httpHeaders: {
            authorization: getAuthorizationBearer()
        }
    }), [ url ]);
    const $pdfTotalPages = useLinked(1);
    const onDocumentLoadSuccess = ({ numPages }) =>  { $pdfTotalPages.set(numPages); $loaded.set(true); }

    return (
        <Document className={ classes.root } file={ pdfFile } onLoadSuccess={ onDocumentLoadSuccess } renderMode="svg" loading={
            <LoadingContainer >
                <Loading />
            </LoadingContainer>
        } >
            { [ ...Array.from(Array($pdfTotalPages.value).keys()) ].map((pageNumber) => <Page key={ pageNumber } pageNumber={ pageNumber + 1 } scale={ $scale.value } />) }
        </Document>
    )
}

const usePdfViewerStyles = makeStyles({
    root: {
        '& div.react-pdf__Page__svg': {
            margin: 'auto'
        }
    }
});

const LoadingContainer = div({
    padding: '50px'
});
